var lib_core = require("lib-core");

var LogicTerminal = require("../../abstract/logicTerminalData.js");
var LogicTerminalInstance = require("./logicTerminalInstance.js");
var PropertyInstanceData = require("./propertyInstanceData.js");

var ComponentInstanceData = function (componentDescription, name) {
    var self = this;

    this.registerInstanceClass(["logicTerminals"], LogicTerminal, LogicTerminalInstance);
    this.registerInstanceClass(["properties"], null, PropertyInstanceData);

    // TODO: see if we can omit this!
    this.registerInstanceClass(["composedSymbol", "symbolInstances", "terminals"]);
    this.registerInstanceClass(["composedSymbol", "symbolInstances", "terminalMap"]);
    this.registerInstanceClass(["packageInstances", "footprintInstances", "pads"]);
    this.registerInstanceClass(["packageInstances", "footprintInstances", "holes"]);
    this.registerInstanceClass(["packageInstances", "terminalMap"]);

    // this.registerPersistentMember(/^logicTerminals/);
    this.registerPersistentMember(["properties"]);
    // lib_core.InstanceBuilder.call(this, componentDescription); //TODO: enable again
    // this.makeUndoable(true);

//HACK //TODO: remove after libcore refactoring
    lib_core.InstanceBuilder.call(this);
    // this.logicTerminals = this.set("logicTerminals", true);
    // this.properties = this.list("properties", true);
    if(componentDescription) {
        this.ancestor(componentDescription);
        self.rebuild();
    }

    this.name = this.value("name", true);
    if (name != undefined) this.name(name);
};
lib_core.inherit(ComponentInstanceData, lib_core.InstanceBuilder);

lib_core.JsonParser.registerClass(ComponentInstanceData, "ComponentInstanceData");

module.exports = ComponentInstanceData;

ComponentInstanceData.prototype.getTitle = function () {
    return this.metaData().description.name();
};

ComponentInstanceData.prototype.getLabelMember = function() {
    var props = this.properties;
    var template;
    var label;

    props.forEach(function(iter, property){
        if(property.template().name() == '_labelTemp') template = property.val();
    });

    //This is a simple version of templates for the label and will get more robust
    //as we decide which templates are official.  Right now there is only <label>
    if(template){
        var match = "";
        var tempSplit = template.split(/[<>]/);
        //tempSplit = tempSplit[0];
        tempSplit.forEach(function(subTemp){
            if(subTemp) match += subTemp;
        });
        props.forEach(function(iter, property){
            if(property.template().name() == match) label = property.val;
        });
    }
    return label;
 };

 ComponentInstanceData.prototype.getLabel = function(){
    var label = this.getLabelMember();

    if(label) return label();
    return null;
 };
